import { Controller } from "@hotwired/stimulus"

// data-controller="lessons--progress"
export default class extends Controller {
  connect() {
    this.element.addEventListener("lesson:loaded", this.updateLessonCard.bind(this))
    this.element.addEventListener("lessons--videos:video-updated", this.syncStatus.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("lesson:loaded", this.updateLessonCard.bind(this))
    this.element.removeEventListener("lessons--videos:video-updated", this.syncStatus.bind(this))
  }

  async completeVideo() {
    await this.toggleVideoCompletion(true)
  }

  async uncompleteVideo() {
    await this.toggleVideoCompletion(false)
  }

  async toggleVideoCompletion(complete) {
    const nowLesson = document.querySelector("#now-lesson")
    const lessonId = nowLesson.dataset.lesson.split("-")[1]
    const videoData = nowLesson.dataset.video

    if (!videoData) return this.toggleLessonCompletion(lessonId, complete)

    const videoId = videoData.split("-")[1]
    const url = complete
      ? `/lessons/${lessonId}/video/${videoId}/user_attended_video`
      : `/lessons/${lessonId}/video/${videoId}/user_not_attended_video`

    await fetch(url, { method: "GET" })
    document.querySelector(`#video-${videoId}`)?.setAttribute("data-attended", complete)
    this.dispatch("video-updated", { detail: { videoId, attended: complete } })
    await this.syncCapsule(lessonId)
  }

  async toggleLessonCompletion(lessonId, complete) {
    const url = complete
      ? `/lessons/${lessonId}/user_attended_lesson`
      : `/lessons/${lessonId}/user_not_attended_lesson`

    await fetch(url, { method: "GET" })
    this.updateLessonIcon(lessonId, complete)
    this.changeButtonComplete(lessonId, complete)
    this.dispatch("lesson-status-changed", { detail: { lessonId, attended: complete } })
    await this.syncCapsule(lessonId)
  }

  async complete(event) {
    const lessonId = this.extractLessonId(event.currentTarget)
    await this.toggleLessonCompletion(lessonId, true)
    this.dispatch("loaded", { detail: { id: Number(lessonId), attended: true } })
  }

  async uncomplete(event) {
    const lessonId = this.extractLessonId(event.currentTarget)
    await this.toggleLessonCompletion(lessonId, false)
    this.dispatch("loaded", { detail: { id: Number(lessonId), attended: false } })
  }

  changeButtonComplete(lessonId, complete) {
    const button = document.querySelector(`#lesson-${lessonId} .lesson-item__status`)
    if (button) {
      button.dataset.action = `click->lessons--progress#${complete ? "uncomplete" : "complete"}`
    }
  }

  extractLessonId(button) {
    const lessonItem = button.closest(".lesson-item")
    return lessonItem ? lessonItem.id.split("-")[1] : null
  }

  updateLessonCard(event) {
    const { id, attended } = event.detail
    this.updateLessonIcon(id, attended)
    this.renderCompletionButton(attended)
  }

  syncStatus(event) {
    const nowLesson = document.querySelector("#now-lesson")
    const totalVideos = document.querySelectorAll(".video-card").length
    const totalCompleted = document.querySelectorAll(".lesson-item__status-icon.is-completed").length

    const lessonId = nowLesson.dataset.lesson.split("-")[1]
    this.updateLessonIcon(lessonId, totalVideos > 0 ? totalVideos === totalCompleted : event.detail.attended)
  }

  updateLessonIcon(lessonId, completed) {
    const icon = document.querySelector(`#lesson-${lessonId} .lesson-item__status-icon`)
    if (!icon) return
    icon.classList.toggle("is-completed", completed)
  }

  renderCompletionButton(attended) {
    const area = document.querySelector(".area-btn-completed")
    if (!area) return

    const action = attended ? "lessons--progress#uncompleteVideo" : "lessons--progress#completeVideo"
    const text = attended ? "Desmarcar" : "Marcar"

    area.innerHTML = `
      <button class="btn btn-completed-video" data-action="${action}">
        ${text} como assistido
      </button>
    `
  }

  async syncCapsule(lessonId) {
    const response = await fetch(`/lessons/${lessonId}/capsule`, {
      method: "GET",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
    })

    const capsule = JSON.parse(await response.text())
    const container = document.querySelector(`#progressive-capsule-${capsule.id}`)
    if (!container) return

    if (capsule.progressive === 100) {
      container.innerHTML = `
        <div class='icon-capsule-completed font-weight-bold'>
          <i class='fa fa-check' aria-hidden='true'></i>
        </div>
        <div class='status font-weight-bold'>Completo</div>
      `
      return
    }

    container.innerHTML = `
      <div class='porcentage font-weight-bold'>${capsule.progressive}%</div>
      <div class='bar font-weight-bold'>
        <div class='progressive-bar'>
          <div style='width: ${capsule.progressive}%;'></div>
        </div>
      </div>
    `
  }
}